import React from 'react'
import { Breadcrumb as AntBreadcrumb } from 'antd'
import { BreadcrumbProps as AntBreadcrumbProps } from 'antd/lib/breadcrumb'

export type BreadcrumbProps = AntBreadcrumbProps

export interface BreadcrumbRoute {
  path: string
  breadcrumbName: string
  children?: Array<{
    path: string
    breadcrumbName: string
  }>
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  className,
  itemRender,
  routes
}) => {
  return (
    <AntBreadcrumb
      className={className}
      routes={routes}
      itemRender={itemRender}
    />
  )
}
